import { TicketType, UserRewardType } from 'v2/constants';

export const REWARD_TYPE_TO_TICKET_TYPE_MAP = {
  [UserRewardType.GOLDEN_TICKET]: TicketType.GOLDEN,
  [UserRewardType.CONTEST_TICKET]: TicketType.CONTEST,
};
